import React, { useEffect, useRef, useState } from "react";
import sportNutrition from "../../../assets/mp4/sportNutrition.mp4";
import "../index.css";
import ModalVideo from "../../ModalVideo";
export default function SportNutrition() {
  const [linkVideo, setLinkVideo] = useState("");
  return (
    <>
      <ModalVideo linkVideo={linkVideo} setLinkVideo={setLinkVideo} />
      <div className="w-100 h-100 position-relative">
        <video autoPlay loop muted className="videoBackground">
          <source src={sportNutrition} type="video/mp4" />
          Seu navegador não suporta vídeos HTML5.
        </video>

        <div className="container">
          <div
            className="tituloHome tituloHome1 text-center"
            onClick={() => {
              setLinkVideo(
                "https://player.vimeo.com/video/809801311?h=5e1ac78efc"
              );
            }}
          >
            Sport Nutrition
          </div>
          <div className="background"></div>
        </div>
      </div>
    </>
  );
}
